import classNames from 'classnames';
import { Heading } from 'yoso';
import { AdventureReward } from '~/components/Adventure/Adventure.hooks';
import { T } from '~/components/I18n';
import { abbreviate } from '~/components/Util/number';
import styles from './AdventureRewardHeading.module.scss';

export type AdventureRewardHeadingProps = AdventureReward & {
  className?: string;
};
export const AdventureRewardHeading = ({
  className,
  title,
  rewardType,
  winnerCount,
  requiredCount,
}: AdventureRewardHeadingProps) => (
  <Heading level={5} className={classNames(styles.root, className)}>
    {(() => {
      switch (rewardType) {
        case 'LOTTERY_NFT':
          return (
            <>
              {title}{' '}
              <span className={styles.unit}>
                (<T name="citizen_unit" options={{ count: winnerCount, 0: winnerCount }} />)
              </span>
              {requiredCount > 0 && (
                <small>
                  <T name="citizen_adventure_winning_num_3" options={[abbreviate(requiredCount)]} />
                </small>
              )}
            </>
          );
        case 'PARTICIPATORY_NFT':
          return (
            <>
              {title}{' '}
              <span className={styles.unit}>
                (<T name="citizen_unit_max" options={{ count: 4, 0: 4 }} />)
              </span>
              <small>
                <T name="citizen_adventure_winning_num_4" />
              </small>
            </>
          );
        case 'UNKNOWN':
          return (
            <>
              {title}
              <small>
                <T name="citizen_adventure_winning_num_4" />
              </small>
            </>
          );
      }
    })()}
  </Heading>
);
